'use client';

import type { HTMLAttributes } from 'react';

import { cn } from '@/lib/utils';

interface SurfaceProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'background' | 'surface';
}

export function Surface({ variant = 'background', className, ...props }: SurfaceProps) {
  return (
    <div
      className={cn(
        'transition-colors duration-hover ease-calm',
        variant === 'background' ? 'bg-bg-0' : 'bg-surface-1',
        className
      )}
      {...props}
    />
  );
}
